export { stripHtml } from './stripHtml';

export function formatNumber(num: number | undefined): string {
  return num != null
    ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    : '';
}

/**
 * Calculate response rate percentage from search request stats
 * Shows how many property owner offers the tenant has responded to
 * @param stats - Object containing property owner response counts and tenant response count
 * @returns Response rate as a percentage (0-100)
 */
export function calculateResponseRate(stats: {
  accepted: number;
  declined: number;
  // eslint-disable-next-line camelcase
  answer_requested: number;
  opened: number;
  tenantResponded: number;
}): number {
  const totalOffers = stats.accepted;
  const tenantResponses = stats.tenantResponded;
  return totalOffers > 0 ? (tenantResponses / totalOffers) * 100 : 100;
}

/**
 * Get color for response rate based on percentage
 * @param rate - Response rate percentage (0-100)
 * @returns Color string (red, orange, or green)
 */
export function getResponseRateColor(rate: number): string {
  if (rate >= 50) {
    return '#52c41a';
  } // Green
  if (rate >= 25) {
    return '#faad14';
  } // Yellow/Orange
  return '#ff4d4f'; // Red
}

/**
 * Calculate average response rate across all search requests
 * @param searchRequests - Array of search requests with stats
 * @returns Average response rate as a percentage (0-100)
 */
export function calculateAverageResponseRate(
  searchRequests: Array<{
    stats: {
      accepted: number;
      tenantResponded: number;
    };
  }>,
): number {
  if (!searchRequests || searchRequests.length === 0) {
    return 100;
  }

  let totalAccepted = 0;
  let totalTenantResponded = 0;

  searchRequests.forEach(sr => {
    totalAccepted += sr.stats.accepted;
    totalTenantResponded += sr.stats.tenantResponded;
  });

  return totalAccepted > 0 ? (totalTenantResponded / totalAccepted) * 100 : 100;
}
